module.exports = __webpack_public_path__ + "img/show-viewport-objects.c3b9a7c3.svg";